import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import DetalheConfiguracaoBilhete from './DetalheConfiguracaoBilhete';
import alterarExibicaoDetalhamentoConfiguracaoBilhete from '../../actions/configuracao-bilhete/alterarExibicaoDetalhamentoConfiguracaoBilhete';

export class ConfiguracaoBilhete extends React.Component {
    constructor (props) {
      super(props)
      this.state = {
        configuracaoSelecionada: null,
      };
    }

    exibirIcone () {      
      if (this.props.configuracao.exibirDetalhe) {
          return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)}>
          &#xE5C7;</i>
      }
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)}>&#xE5C5;</i>
    }

    selecionar(configuracao) {      
      if (configuracao.nomeCidade !== null) {        
          const cidadeDeOrigem = {
            id: configuracao.codigoCidade,
            nome: configuracao.nomeCidade,
            uf: configuracao.uf
          };
        this.props.selecionarOrigem(cidadeDeOrigem);
      }

      this.props.selecionarBilhete(configuracao)
    }

    render () {
        return (
          <div className="geral representante">
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
              getGestorEmpresa(this.props.empresaSelecionada.id),
              getAdminEmpresa(this.props.empresaSelecionada.id)]}>
              <div className="resumo">
                <div className="row">
                  <div className="col-md-1 col-lg-1 col-xl-1" onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)} style={{ cursor: 'pointer' }}>
                    {this.exibirIcone()}
                  </div> 
                  <div className="col">
                      <span className="titulo-mobile">Cidade:&nbsp;</span>{this.props.configuracao.cidade ? this.props.configuracao.cidade.nomeComUf : ''}
                  </div>
                  <div className="col">
                    <span className="titulo-mobile">Regra:&nbsp;</span>{this.props.configuracao.regra.valor}
                  </div>
                </div>
                <DetalheConfiguracaoBilhete configuracao={this.props.configuracao} selecionarBilhete={this.selecionar.bind(this)} />
              </div>
            </Autorizacao>
          </div>
        )
      }
}

export function mapStateToProps (state) {
    return {
      empresaSelecionada: state.empresaSelecionada
    }
  }

export default connect(mapStateToProps, {
  changeFieldValue,      
  selecionarOrigem,
  alterarExibicaoDetalhamentoConfiguracaoBilhete
})(reduxForm({
    form: 'formCadastrarConfiguracaoBilhete'
  })(ConfiguracaoBilhete))
